module.exports = __webpack_public_path__ + "static/media/pic7.312f96e4.jpg";